




import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'GStudentRecordItemCell',
  computed: {},
  methods: {},
})
export default class GStudentRecordItemCell extends Vue {
  mounted() {}
}
